import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	howToUseTitle: {
		id: 'trial.thomas.howToUse.title',
		defaultMessage: 'Ideas on how to Use Calm with young children',
		description: 'thomas howToUse title',
	},
	skillTitle: {
		id: 'trial.thomas.howToUse.skillTitle',
		defaultMessage: 'Learn the Skill of Meditation',
		description: 'thomas howToUse skill title',
	},
	skillSubtitle: {
		id: 'trial.thomas.howToUse.skillSubtitle',
		defaultMessage:
			'Nurture kindness, ease anxiety and calm anger with meditations for kids of all ages (2+).',
		description: 'thomas howToUse skill subtitle',
	},
	breatheTitle: {
		id: 'trial.thomas.howToUse.breatheTitle',
		defaultMessage: 'Breathing Exercises',
		description: 'thomas howToUse breathe title',
	},
	breatheSubtitle: {
		id: 'trial.thomas.howToUse.breatheSubtitle',
		defaultMessage: 'Teach your kids to breathe deeply with Calm’s interactive breath bubble.',
		description: 'thomas howToUse breathe subtitle',
	},
	driftTitle: {
		id: 'trial.thomas.howToUse.driftTitle',
		defaultMessage: 'Drift Off with a Lullaby',
		description: 'thomas howToUse drift title',
	},
	driftSubtitle: {
		id: 'trial.thomas.howToUse.driftSubtitle',
		defaultMessage: 'Explore soothing lullabies to help your child drift off to dreamland.',
		description: 'thomas howToUse subtitle',
	},
	listenTitle: {
		id: 'trial.thomas.howToUse.listenTitle',
		defaultMessage: 'Listen to a Calm Soundscape',
		description: 'thomas howToUse listen title',
	},
	listenSubtitle: {
		id: 'trial.thomas.howToUse.listenSubtitle',
		defaultMessage: 'Unwind and relax with the sound of rain or gentle ocean waves.',
		description: 'thomas howToUse listen subtitle',
	},
	walkingTitle: {
		id: 'trial.thomas.howToUse.walkingTitle',
		defaultMessage: 'Mindful Walking',
		description: 'thomas howToUse walking title',
	},
	walkingSubtitle: {
		id: 'trial.thomas.howToUse.walkingSubtitle',
		defaultMessage: 'Enjoy a peaceful walking practice in the Mindfulness with Mallika series for kids.',
		description: 'thomas howToUse walking subtitle',
	},
	whimsicalTitle: {
		id: 'trial.thomas.howToUse.whimsicalTitle',
		defaultMessage: 'Listen to a Whimsical Sleep Story',
		description: 'thomas howToUse whimsical title',
	},
	whimsicalSubtitle: {
		id: 'trial.thomas.howToUse.whimsicalSubtitle',
		defaultMessage: 'Get cozy with one of our hundreds of bedtime stories for kids.',
		description: 'thomas howToUse whimsical subtitle',
	},
});
